"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.caseOne = exports.twoDigit = exports.singleDigit = void 0;
exports.singleDigit = [
    '', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', ''
];
exports.twoDigit = [
    '', 'ten', 'twenty', 'thirty', 'fourty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety', ''
];
exports.caseOne = [
    '', 'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen', ''
];
